<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    width="880px"
    :mask-closable="false"
    :centered="true"
    :footer="null"
    :confirm-loading="confirmLoading"
    @cancel="cancelHanler"
  >
    <div class="expen-service-box">
      <template v-if="page===1">
        <card
          :up="false"
          @openService="openService"
        />
      </template>
      <template v-else-if="page===2">
        <open-ser-second
          @closeHandler="closeHandler"
          @formHandler="formHandler"
        />
      </template>
      <template v-else-if="page===3">
        <div class="open-suc-tip">
          <i class="iconfont iconicon-test70" />
          <p>{{ $t('message["1313"]') }}!</p>
        </div>
      </template>
    </div>
  </a-modal>
</template>
<script>
import OpenSerSecond from './OpenSerSecond'
import Card from './Card'
export default {
  components: {
    Card,
    OpenSerSecond
  },
  props: {
    cId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      page: 1
    }
  },
  computed: {
    modalTit () {
      return this.$t('message["353"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      // this.form.validateFieldsAndScroll(async (err, values) => {
      //   if (!err) {
      //     const formDatas = Object.assign(values, { cid: this.cId })
      //     const chain = await this.ajaxCreateProject(formDatas)
      //     chain.params(formDatas)
      //       .setForm(this.form)
      //       .fetch()
      //     this.form.resetFields()
      //     this.isLimitDialogShow = false
      //   }
      // })
    },
    openService () {
      this.page = 2
    },
    closeHandler () {
      this.isLimitDialogShow = false
      this.page = 1
    },
    cancelHanler () {
      this.isLimitDialogShow = false
      // this.page = 1
      setTimeout(() => {
        if (this.page === 3) {
          location.reload()
        }
      }, 1000)
    },
    formHandler () {
      this.page = 3
      setTimeout(() => {
        location.reload()
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.open-suc-tip {
  text-align: center;
  margin: 80px auto;
  i {
    color: #42C27E;
    font-size: 80px;
  }
  p {
    line-height: 36px;
    font-size: 18px;
    margin-top: 24px;
  }
}
</style>
